// @ts-nocheck
import {
  STUDIO_WAM_RETURN_COOKIE,
  STUDIO_WAM_RETURN_KEY,
  decodeWamReturnCookie,
  parseWamReturnPayload
} from "../lib/wamReturn";

const STUDIO_PUSH_PROMPT_KEY = "yatishara-studio-push-prompt-v1";

export function readStudioPushPromptState() {
  if (typeof window === "undefined") return "";
  try {
    return String(window.localStorage.getItem(STUDIO_PUSH_PROMPT_KEY) || "").trim();
  } catch {
    return "";
  }
}

export function writeStudioPushPromptState(value) {
  try {
    window.localStorage.setItem(STUDIO_PUSH_PROMPT_KEY, value);
  } catch {
    /* ignore */
  }
}
function readWamReturnCookie() {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${STUDIO_WAM_RETURN_COOKIE}=([^;]*)`),
  );
  return decodeWamReturnCookie(match?.[1] ? match[1] : null);
}

function clearWamReturnCookie() {
  if (typeof document === "undefined") return;
  document.cookie = `${STUDIO_WAM_RETURN_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
}

export function readWamReturn() {
  if (typeof window === "undefined") return null;
  const fromCookie = readWamReturnCookie();
  for (const store of [window.sessionStorage, window.localStorage]) {
    try {
      const parsed = parseWamReturnPayload(
        JSON.parse(store.getItem(STUDIO_WAM_RETURN_KEY) || "null"),
      );
      if (parsed) {
        return { ...parsed, ...(fromCookie || {}) };
      }
    } catch {
      /* ignore */
    }
  }
  return fromCookie;
}

export function stashWamReturn(next) {
  if (typeof window === "undefined" || !next || typeof next !== "object") return;
  const merged = { ...(readWamReturn() || {}), ...next, at: Date.now() };
  const raw = JSON.stringify(merged);
  try {
    window.sessionStorage.setItem(STUDIO_WAM_RETURN_KEY, raw);
  } catch {
    /* ignore */
  }
  try {
    window.localStorage.setItem(STUDIO_WAM_RETURN_KEY, raw);
  } catch {
    /* ignore */
  }
}

export function clearWamReturn() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(STUDIO_WAM_RETURN_KEY);
  } catch {
    /* ignore */
  }
  try {
    window.localStorage.removeItem(STUDIO_WAM_RETURN_KEY);
  } catch {
    /* ignore */
  }
  clearWamReturnCookie();
}

export function billingSectionFromStash(stored) {
  if (stored?.billing === "plans" || stored?.billing === "invoices" || stored?.billing === "topup") {
    return stored.billing;
  }
  return "plans";
}

export function captureWamReturnFromUrl() {
  if (typeof window === "undefined") return;
  const fromCookie = readWamReturnCookie();
  if (fromCookie?.abandoned) {
    clearWamReturnCookie();
    clearWamReturn();
    return;
  }
  if (fromCookie) {
    stashWamReturn(fromCookie);
    clearWamReturnCookie();
  }
  const pathPay = window.location.pathname.match(/\/pay\/done\/([^/]+)\/?$/i);
  const params = new URLSearchParams(window.location.search);
  const paymentId = params.get("paymentId") || (pathPay ? decodeURIComponent(pathPay[1]) : "");
  const academyCourse = params.get("academyCourse");
  const billing = params.get("billing");
  const result = (params.get("result") || "").toUpperCase();
  const identifier = (params.get("identifier") || "").trim();
  const amountRaw = Number.parseInt(params.get("amount") || "", 10);
  const wamOk = result === "OK" || fromCookie?.wamOk === true;
  if (!wamOk) {
    if (pathPay || result) {
      for (const key of [
        "payment",
        "paymentId",
        "billing",
        "academyCourse",
        "result",
        "amount",
        "identifier",
        "reference",
        "signature",
      ]) {
        params.delete(key);
      }
      window.history.replaceState(
        {},
        "",
        pathPay ? `/${params.toString() ? `?${params}` : ""}` : `${window.location.pathname}${params.toString() ? `?${params}` : ""}${window.location.hash}`,
      );
    }
    return;
  }
  stashWamReturn({
    ...(paymentId ? { paymentId } : {}),
    ...(academyCourse ? { academyCourse } : {}),
    ...(billing === "plans" ||
    billing === "invoices" ||
    billing === "topup" ||
    billing === "academy"
      ? { billing }
      : {}),
    ...(identifier ? { identifier } : {}),
    ...(Number.isFinite(amountRaw) && amountRaw > 0 ? { amountCents: amountRaw } : {}),
    ...(wamOk ? { wamOk: true } : {}),
    at: Date.now(),
  });
  for (const key of [
    "payment",
    "paymentId",
    "billing",
    "academyCourse",
    "result",
    "amount",
    "identifier",
    "reference",
    "signature",
  ]) {
    params.delete(key);
  }
  if (pathPay) {
    window.history.replaceState({}, "", `/${params.toString() ? `?${params}` : ""}`);
    return;
  }
  const cleaned = `${window.location.pathname}${params.toString() ? `?${params}` : ""}${window.location.hash}`;
  window.history.replaceState({}, "", cleaned || "/");
}
